import axiosInstance from '../axiosInterceptor/axiosInstance'

const postGameScore = async ({ orgId, gameId, scores, keepExistingStats }) => {
  const url = `v1/orgs/${orgId}/games/${gameId}/stats/score`
  const response = await axiosInstance.post(url, { scores, keepExistingStats })
  return response?.data
}

export default postGameScore
